import { DARK_THEME, LIGHT_THEME } from "../actions/theme.action";
import darkTheme from "../../theme/dark.theme";
import lightTheme from "../../theme/light.theme";

export default (state = { ...darkTheme }, action) => {
  switch (action.type) {
    case DARK_THEME:
      return { ...darkTheme };
    case LIGHT_THEME:
      return { ...lightTheme };
    default:
      return state;
  }
};
